import { useId } from '@reach/auto-id';
import { useDescendant } from "../../hooks";
import { useContext } from 'react';
import { MenuListContext } from "./MenuListContext";
export var useRegisterMenuItem = function useRegisterMenuItem(ref) {
  var id = useId();

  var _useContext = useContext(MenuListContext),
      selectedId = _useContext.selectedId,
      dispatch = _useContext.dispatch;

  useDescendant(id, ref);
  return {
    isSelected: selectedId === id,
    select: function select() {
      dispatch({
        type: 'SELECT',
        payload: {
          id: id,
          mouse: false
        }
      });
    }
  };
};